const today = new Date();
const curHr = today.getHours();

export const getUserTime = (): string => {
    if (curHr < 12) {
        return 'Good Morning';
    } else if (curHr < 18) {
        return 'Good Afternoon';
    } else {
        return 'Good Evening';
    }
};
